import { render, staticRenderFns } from "./xy+.vue?vue&type=template&id=38396af2&scoped=true"
import script from "./xy+.vue?vue&type=script&lang=js"
export * from "./xy+.vue?vue&type=script&lang=js"
import style0 from "./xy+.vue?vue&type=style&index=0&id=38396af2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38396af2",
  null
  
)

export default component.exports